/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import { Switch, Redirect, Route } from 'react-router-dom';
import GiftStore from 'app/scenes/giftstore/GiftStore';
import GiftPurchases from 'app/scenes/giftstore/GiftPurchases';
import NavBarFlat from 'app/components/commons/NavBarFlat';
import NavBarItemFlat from 'app/components/commons/NavBarItemFlat';
import Page from 'app/containers/parts/Page';
import t from 'app/utils/translate';
import Responsive from 'app/components/responsive/Responsive';
import desktopImagePlayChip from 'app/images/playchip.jpg';
import mobileImagePlayChip from 'app/images/playchip-mobile.jpg';

type Props = {
  giftStoreName: string,
  isSignedIn?: boolean,
};

const defaultProps = {
  isSignedIn: false,
};

function GiftRouteHandler({ giftStoreName, isSignedIn }: Props) {
  return (
    <Page>
      <Responsive tabletPortrait desktop>
        {isLargeScreen =>
          (isLargeScreen ? (
            <img src={desktopImagePlayChip} alt="" width="100%" height="auto" />
          ) : (
            <img src={mobileImagePlayChip} alt="" width="100%" height="auto" />
          ))
        }
      </Responsive>
      {isSignedIn && (
        <NavBarFlat>
          <NavBarItemFlat link="/gift/store">{t(giftStoreName)}</NavBarItemFlat>
          <NavBarItemFlat link="/gift/purchases">{t('Purchases')}</NavBarItemFlat>
        </NavBarFlat>
      )}
      <Switch>
        <Route path="/gift/store" component={GiftStore} />
        {isSignedIn && <Route path="/gift/purchases" component={GiftPurchases} />}
        <Redirect exact from="/gift" to="/gift/store" />
      </Switch>
    </Page>
  );
}

GiftRouteHandler.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    giftStoreName: state.settings.giftStoreName,
    isSignedIn: state.user.isSignedIn,
  };
}

export default connect(mapStateToProps)(GiftRouteHandler);
